module.exports = __webpack_public_path__ + "img/ta.ta6569311.svg";